import React from 'react';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from '../ui-components/IconButton';
import useAppContext from 'flow/hooks/useAppContext';

interface ThreadActionButtonProps {
    onThreadOpenClicked: () => void;
    hasThreadMessages?: boolean;
}

const ThreadActionButton = ({
    onThreadOpenClicked,
    hasThreadMessages,
}: ThreadActionButtonProps) => {
    const { i18next } = useAppContext();
    const tooltip = hasThreadMessages
        ? 'ThreadMessages.ViewThread.Tooltip'
        : 'ThreadMessages.CreateThread.Tooltip';
    return (
        <IconButton
            tooltipLabel={i18next.t(tooltip)}
            tooltipPlacement="bottom"
            onClick={() => onThreadOpenClicked()}
            className="size-9 rounded-sm text-gray-600 hover:bg-gray-100"
        >
            <Icon
                iconKey={hasThreadMessages ? 'viewThreads' : 'addThread'}
                size="1.3rem"
            />
        </IconButton>
    );
};

export default ThreadActionButton;
